import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { QueryStatus, authAxios } from "../../utils";
import { RootState } from "../../redux/store";
import { dateFormatterDayMonthYearLong2Digits } from "@qivia/ui";
import { CompanyDeletedApi } from "./companiesDeletedApi";

export interface CompaniesDeletedState {
  companiesDeletedDataStatus: QueryStatus;
  companiesDeletedData: CompanyDeletedApi[];
}

const initialState: CompaniesDeletedState = {
  companiesDeletedDataStatus: "idle",
  companiesDeletedData: [],
};

export const companiesDeletedDataAsync = createAsyncThunk(
  "companiesDeletedData/call",
  async () => {
    const axios = authAxios();
    const response = await axios.get<CompanyDeletedApi[]>(
      `/companies/deleted_data`,
    );
    return response.data
      .sort(
        (a, b) =>
          new Date(b.deleteAt).getTime() - new Date(a.deleteAt).getTime(),
      )
      .map((r) => {
        return {
          ...r,
          deleteAt: dateFormatterDayMonthYearLong2Digits(new Date(r.deleteAt)),
          orderBlockedAt: r.orderBlockedAt
            ? dateFormatterDayMonthYearLong2Digits(new Date(r.orderBlockedAt))
            : null,
          providerDeletedAt: r.providerDeletedAt
            ? dateFormatterDayMonthYearLong2Digits(
                new Date(r.providerDeletedAt),
              )
            : null,
        };
      });
  },
);

export const companiesDeletedSlice = createSlice({
  name: "companiesDeleted",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(companiesDeletedDataAsync.pending, (state) => {
        state.companiesDeletedDataStatus = "processing";
      })
      .addCase(companiesDeletedDataAsync.fulfilled, (state, action) => {
        state.companiesDeletedDataStatus = "success";
        state.companiesDeletedData = action.payload;
      })
      .addCase(companiesDeletedDataAsync.rejected, (state) => {
        state.companiesDeletedDataStatus = "failed";
      });
  },
});

export const selectCompaniesDeletedData = (state: RootState) =>
  state.companiesDeleted.companiesDeletedData;
export const selectCompaniesDeletedDataStatus = (state: RootState) =>
  state.companiesDeleted.companiesDeletedDataStatus;

export default companiesDeletedSlice.reducer;
